module.exports = __webpack_public_path__ + "static/img/amgo_third.3c35040a.png";